<template>
    <v-app id="app" class="grey">
        <v-content class="">
            <div>
               
                <Home/>
                <preFooter/>
                <mainFooter/>
            </div>
            </v-content>
        </v-app>
</template>

<script>
    import Home from './components/Home.vue';
    import HeaderNav from './components/HeaderNav.vue';
    import mainFooter from './components/mainFooter.vue';
    import preFooter from './components/preFooter.vue';
    export default {
        name: 'app',
        components: {
            Home, HeaderNav, mainFooter, preFooter
        }
    };
</script>

<style>
</style>

